// extracted by mini-css-extract-plugin
export default {"firstRow":"FirstRow_firstRow__FMsMQ"};